// @ts-nocheck

export default {
    data() {
        return {
            validationErrors: [],
            formIndexes: [],
        };
    },
    methods: {
        getFormGroupClass(field, index = undefined) {
            const validationErrors = isValidIndex(index)
                ? getErrorForIndex(this.validationErrors, this.formIndexes, index)
                : this.validationErrors;

            if (validationErrors[field]) {
                return "field form-group has-error";
            }

            return "field form-group";
        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        getValidationMessage(field, index = undefined) {
            const validationErrors = isValidIndex(index)
                ? getErrorForIndex(this.validationErrors, this.formIndexes, index)
                : this.validationErrors;

            return validationErrors[field] ? validationErrors[field].join(" ") : "";
        },
        updateValidationErrors(validationErrors, isOneFormError = true) {
            validationErrors = validationErrors || [];

            if (isOneFormError) {
                this.validationErrors = {};
                validationErrors.forEach(error => {
                    this.validationErrors[error.field] = error.message;
                });
            } else {
                this.validationErrors = [];
                validationErrors.forEach((singleFormErrors, index) => {
                    this.validationErrors[index] = singleFormErrors.message;
                });
            }
        },
        clearFormIndex() {
            this.formIndexes = [];
        },
        addFormIndex(index) {
            this.formIndexes.push(index);
            this.formIndexes.sort((a, b) => a - b);
        },
        removeFormIndex(index) {
            this.formIndexes = this.formIndexes.filter(element => element !== index);
            // https://stackoverflow.com/a/76844886
            this.validationErrors.splice(index, 1);
        },
    },
};

function getErrorForIndex(validationErrors, allIndexes, index) {
    const positionOfIndex = allIndexes.indexOf(index);

    return validationErrors[positionOfIndex] || {};
}

function isValidIndex(index) {
    return index !== undefined && index !== null && index >= 0;
}
